<script setup>
import { ref } from 'vue';
import { useIntersectionObserver } from '@vueuse/core';

const { options } = defineProps({
  options: {
    type: Object,
    default: () => ({ root: document, rootMargin: '100px 0 100px 0)' }),
  },
});

const emit = defineEmits(['observed']);
const observedElement = ref('');
const wasIntersecting = ref(false);

useIntersectionObserver(
  observedElement,
  ([{ isIntersecting }]) => {
    if (isIntersecting && !wasIntersecting.value) {
      emit('observed');
    }
    wasIntersecting.value = isIntersecting;
  },
  options
);
</script>

<template>
  <div ref="observedElement" class="h-6 w-full" />
</template>
